import { GetAssignmentHistoryLayerListResponse } from '@/services';

import { formatDate, map, showDataGridWithSymbol } from 'utils';

export const formatAssignmentHistoryLayerDetail = (
	input: GetAssignmentHistoryLayerListResponse[number]
) => {
	return {
		...input,
		assignmentApplicantPerRequestApplicant: showDataGridWithSymbol(
			Number(input?.assignmentApplicant) +
				Number(input?.additionalAssignmentApplicant || 0),
			Number(input?.requestApplicant)
		),
		allocationPeriod: showDataGridWithSymbol(
			formatDate(input?.workStartDate),
			formatDate(input?.workEndDate),
			'~'
		),
		workStartDate: formatDate(input?.workStartDate),
		workEndDate: formatDate(input?.workEndDate),
	};
};

export const formatAssignmentHistoryLayerList = (
	input: GetAssignmentHistoryLayerListResponse
) => {
	return map(input, formatAssignmentHistoryLayerDetail);
};
